const ingredientsList = {
  portions: 4,
  elAmounts: '',
  elBtnTag: '',
  elBtnPortions: '',
  init() {
    this.elAmounts = $q('.ingredient-amount')
    this.elBtnTag = $q('.portions button')
    this.elBtnPortions = $q('.portions a')

    if (!this.elAmounts.first) return

    this.calcPortions(this.portions)
    this.calcBtn()
  },
  calcBtn() {
    this.elBtnPortions.listen('click', (btn, e) => {
      e.preventDefault()

      this.portions = btn.dataset.people
      this.calcPortions(this.portions)
    })
  },
  calcPortions($portion) {
    this.elAmounts.loop(item => {
      const elAmount = item.querySelector('.amount')
      const amount = Math.round(item.dataset.amount * $portion * 10) / 10

      elAmount.innerText = amount
      this.btnTagText()
    })
  },
  btnTagText() {
    this.elBtnTag.loop(el => (el.innerText = this.portions + (this.portions > 1 ? ' Άτομα' : ' Άτομο')))
  }
}
export default ingredientsList
